// @ts-ignore - antiquated class that needs to be migrated to TS
import { reactMount } from '../../lib/reactMount';
import { useEffect, useRef } from 'react';
import { loadScript } from '../../helpers/ScriptLoader';
import { getRegion, getRegionIdentifiable } from '../../helpers/RegionService';
// @ts-ignore - this file is currently JS and needs to be migrated to TS
import { useIsViewPortLessOrEqualTo as mobileOrTabletViewWidth } from '../../hooks/useIsViewPortLessOrEqualTo';

interface ChatbotUmbracoProps {
  ZendeskKey: string;
  ZendeskId: string;
  ShowInFallbackRegion: boolean;
  IsPageExcluded: boolean;
  ShowPageOnMobile: boolean;
}

const ChatbotBlock = ({ dataset }: any) => {
  const props = useRef<ChatbotUmbracoProps>(
    JSON.parse(dataset.umbraco),
  ).current;
  const pilotRegion = inPilotRegion(props.ShowInFallbackRegion);
  const isDesktop = !mobileOrTabletViewWidth(1279);
  const showChatbot = pilotRegion && (isDesktop || props.ShowPageOnMobile);

  console.log('ChatbotBlock props:', props);
  console.log('ChatbotBlock showChatbot:', showChatbot);

  const zendeskSnippetSrc = `https://static.zdassets.com/ekr/snippet.js?key=${props.ZendeskKey}`;

  useEffect(() => {
    if (showChatbot) {
      loadScript({
        id: props.ZendeskId,
        src: zendeskSnippetSrc,
      }).catch((error) => {
        console.error('Error loading Zendesk widget:', error);
      });
    }
  }, [props.ZendeskId, zendeskSnippetSrc, showChatbot]);

  return null;
};

// Pilot should only be enabled for AU and GB to start, if showInDefaultRegion is enabled then we can show in NZ
function inPilotRegion(showInDefaultRegion: boolean): boolean {
  // as all non-idenifiable users are bucketed as NZ, we need to ensure we have an actual NZ identified user
  const identifiable = getRegionIdentifiable()?.identifiable;
  const region = getRegion()?.countryIso;

  switch (region) {
    case 'AU':
      return true;
    case 'GB':
      return true;
    case 'NZ':
      return identifiable === true ? true : showInDefaultRegion; // if the user is identifiable and in NZ, show the chatbot, if they are not identifiable, fall back to showInDefaultRegion value
    default:
      return false;
  }
}

reactMount('Chatbot', ChatbotBlock);
